import React, { useState } from 'react';
import ModalSuccessDefault from '@/components/Modals/ModalSuccessDefault';
import ChangeMobile from '@/components/Modals/ValidateCellPhone/ChangeMobile';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Modal, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/system';
import ResetAlternativeEmail from './ResetAlternativeEmail';
import ResetConfigureNotification from './ResetConfigureNotification';
import ResetDisplayName from './ResetDisplayName';
import ResetEmail from './ResetEmail';
import ResetName from './ResetName';
import ResetPassword from './ResetPassword';
import ResetPhone from './ResetPhone';
import ResetSocialMedias from './ResetSocialMedia';

enum CurrentResetUsersInfoModal {
  CLOSED,
  RESET_DISPLAY_NAME,
  RESET_NAME,
  RESET_EMAIL,
  RESET_PHONE,
  RESET_ALTERNATIVE_EMAIL,
  RESET_SOCIAL_MEDIA,
  RESET_PASSWORD,
  RESET_CONFIGURE_NOTIFICATION,
}

interface IModalResetUsersInfoProps {
  currentModal: CurrentResetUsersInfoModal;
  handleClose: () => void;
  returnToHome: () => void;
  closeModalMyAccount: () => void;
}

interface IModalSuccessData {
  isOpen: boolean;
  text: string;
}

const ModalResetUsersInfo = ({
  currentModal,
  handleClose,
  returnToHome,
  closeModalMyAccount,
}: IModalResetUsersInfoProps) => {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));

  const isConfigureNotification =
    currentModal === CurrentResetUsersInfoModal.RESET_CONFIGURE_NOTIFICATION;

  const [isOpenModalChangeMobile, setIsOpenModalChangeMobile] = useState(false);

  const [modalSuccessData, setModalSuccessData] = useState<IModalSuccessData>({
    isOpen: false,
    text: '',
  });

  const onClose = () =>
    currentModal === CurrentResetUsersInfoModal.RESET_SOCIAL_MEDIA ||
    currentModal === CurrentResetUsersInfoModal.RESET_PASSWORD
      ? returnToHome()
      : handleClose();

  const onSuccess = (value: IModalSuccessData) => {
    onClose();
    setModalSuccessData(value);
  };

  return (
    <>
      <Modal
        aria-labelledby="modal-resets-info"
        aria-describedby="modal-resets-info-description"
        sx={{ overflowY: 'auto', display: 'grid', placeItems: 'center' }}
        open={currentModal !== CurrentResetUsersInfoModal.CLOSED}
        onClose={onClose}
      >
        <Box
          sx={
            isConfigureNotification
              ? {
                  boxShadow: '0px 1px 1px 0px #0000001A',
                  background: '#FFFFFF',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  height: '100vh',
                }
              : {
                  background: '#FAFAFA',
                  borderRadius: smUp ? '10px' : '0',
                  width: smUp ? '456px' : '100vw',
                  minHeight: smUp ? '528px' : '100vh',
                  display: 'flex',
                  flexDirection: 'column',
                }
          }
        >
          <Box
            sx={{
              boxShadow: smUp ? 'none' : '0px 1px 1px 0px #0000001A',
              background: smUp ? 'none' : '#FFFFFF',
              justifyContent: `flex-${
                smUp && !isConfigureNotification ? 'end' : 'start'
              }`,
              display: 'flex',
              alignItems: 'center',
              padding: '18px 16px',
              position: 'relative',
              height: '68px',
            }}
          >
            <IconButton
              data-testid="button-close-reset-users-info"
              onClick={onClose}
              sx={{
                color: '#000000',
              }}
            >
              {smUp && !isConfigureNotification ? (
                <CloseIcon />
              ) : (
                <ArrowBackIcon />
              )}
            </IconButton>
            {(isConfigureNotification || !smUp) && (
              <Typography
                variant="h6"
                component="h2"
                sx={{
                  position: 'absolute',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 'max-content',
                }}
              >
                {
                  {
                    [CurrentResetUsersInfoModal.CLOSED]: '',
                    [CurrentResetUsersInfoModal.RESET_SOCIAL_MEDIA]:
                      'Redes sociais',
                    [CurrentResetUsersInfoModal.RESET_EMAIL]: 'Meu e-mail',
                    [CurrentResetUsersInfoModal.RESET_PHONE]: 'Meu celular',
                    [CurrentResetUsersInfoModal.RESET_DISPLAY_NAME]: 'Apelido',
                    [CurrentResetUsersInfoModal.RESET_NAME]: 'Meu nome',
                    [CurrentResetUsersInfoModal.RESET_ALTERNATIVE_EMAIL]:
                      'E-mail alternativo',
                    [CurrentResetUsersInfoModal.RESET_PASSWORD]: 'Minha Conta',
                    [CurrentResetUsersInfoModal.RESET_CONFIGURE_NOTIFICATION]:
                      'Configurar notificação',
                  }[currentModal]
                }
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: '1',
              paddingX: isConfigureNotification ? '' : smUp ? '38px' : '16px',
            }}
          >
            {
              {
                [CurrentResetUsersInfoModal.CLOSED]: <></>,
                [CurrentResetUsersInfoModal.RESET_NAME]: (
                  <ResetName onSuccess={onSuccess} handleClose={onClose} />
                ),
                [CurrentResetUsersInfoModal.RESET_DISPLAY_NAME]: (
                  <ResetDisplayName
                    onSuccess={onSuccess}
                    handleClose={onClose}
                  />
                ),
                [CurrentResetUsersInfoModal.RESET_EMAIL]: (
                  <ResetEmail onSuccess={onSuccess} handleClose={onClose} />
                ),
                [CurrentResetUsersInfoModal.RESET_PHONE]: (
                  <ResetPhone
                    onSuccess={() => {
                      onClose();
                      setIsOpenModalChangeMobile(true);
                    }}
                    handleClose={onClose}
                  />
                ),
                [CurrentResetUsersInfoModal.RESET_ALTERNATIVE_EMAIL]: (
                  <ResetAlternativeEmail
                    onSuccess={onSuccess}
                    handleClose={onClose}
                  />
                ),
                [CurrentResetUsersInfoModal.RESET_SOCIAL_MEDIA]: (
                  <ResetSocialMedias
                    onSuccess={onSuccess}
                    handleClose={onClose}
                  />
                ),
                [CurrentResetUsersInfoModal.RESET_PASSWORD]: (
                  <ResetPassword onSuccess={onSuccess} handleClose={onClose} />
                ),
                [CurrentResetUsersInfoModal.RESET_CONFIGURE_NOTIFICATION]: (
                  <ResetConfigureNotification />
                ),
              }[currentModal]
            }
          </Box>
        </Box>
      </Modal>
      <ModalSuccessDefault
        isOpen={modalSuccessData.isOpen}
        handleClose={() =>
          setModalSuccessData(prevState => ({ ...prevState, isOpen: false }))
        }
        title="Tudo certo!"
        text={modalSuccessData.text}
      />
      <ChangeMobile
        isOpen={isOpenModalChangeMobile}
        onSuccess={() => {
          setIsOpenModalChangeMobile(false);
          closeModalMyAccount();
        }}
        onClose={() => setIsOpenModalChangeMobile(false)}
      />
    </>
  );
};

export { CurrentResetUsersInfoModal };
export type { IModalResetUsersInfoProps, IModalSuccessData };
export default ModalResetUsersInfo;
